import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const TIPO_INCIDENTE = ["Acidente de trabalho","Falecimento de colaborador","Falecimento de familiar","Acidente ferroviário","Violência no trabalho","Situação de crise coletiva","Catástrofe natural","Outro"];
const LOCAIS = ["Lisboa","Porto","Coimbra","Entroncamento","Aveiro","Braga","Faro","Outro"];
const SECTIONS = ["1. Empresa e contacto","2. Dados do incidente","3. Avaliação de necessidades","4. Intervenção","5. Seguimento"];

const FInput = ({value,onChange,placeholder,type="text"}) =>
  <input type={type} value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
    style={{width:"100%",padding:"8px 10px",border:"1px solid #E4DEFA",borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none",boxSizing:"border-box"}}/>;

const FSelect = ({value,onChange,options}) =>
  <select value={value||""} onChange={e=>onChange(e.target.value)}
    style={{width:"100%",padding:"8px 10px",border:"1px solid #E4DEFA",borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none"}}>
    <option value="">Seleccionar...</option>
    {options.map(o=><option key={o} value={o}>{o}</option>)}
  </select>;

const FTextarea = ({value,onChange,placeholder,rows=3}) =>
  <textarea value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder} rows={rows}
    style={{width:"100%",padding:"8px 10px",border:"1px solid #E4DEFA",borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none",resize:"vertical",boxSizing:"border-box"}}/>;

const Row = ({label,note,children}) =>
  <div style={{padding:"10px 0",borderBottom:"1px solid #E4DEFA"}}>
    <div style={{fontSize:13,fontWeight:600,color:"#1A1A2E",marginBottom:6}}>{label}</div>
    {note&&<div style={{fontSize:11,color:"#8888AA",marginBottom:6,fontStyle:"italic"}}>i {note}</div>}
    {children}
  </div>;

const BtnToggle = ({options,value,onChange,colors}) =>
  <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
    {options.map(op=>{
      const active=value===op;
      const col=colors?.[op]||{border:"#691FB1",bg:"#EDE7F6",text:"#691FB1"};
      return <button key={op} type="button" onClick={()=>onChange(op)}
        style={{flex:1,padding:"9px",border:`2px solid ${active?col.border:"#E4DEFA"}`,borderRadius:8,background:active?col.bg:"white",color:active?col.text:"#8888AA",fontSize:13,cursor:"pointer",fontWeight:700,fontFamily:"system-ui",minWidth:80}}>
        {op}
      </button>;
    })}
  </div>;

const SimNao = ({value,onChange}) =>
  <BtnToggle options={["Sim","Nao"]} value={value===true?"Sim":value===false?"Nao":""} onChange={v=>onChange(v==="Sim")}
    colors={{Sim:{border:"#27AE60",bg:"#EAFAF1",text:"#27AE60"},Nao:{border:"#E74C3C",bg:"#FDEDEC",text:"#E74C3C"}}}/>;

export default function FichaGIC({projectId,projectName,codigoCaso,onClose}){
  const [step,setStep]=useState("check");
  const [ficha,setFicha]=useState(null);
  const [loading,setLoading]=useState(true);
  const [password,setPassword]=useState("");
  const [newPass,setNewPass]=useState("");
  const [newPass2,setNewPass2]=useState("");
  const [error,setError]=useState("");
  const [saving,setSaving]=useState(false);
  const [saved,setSaved]=useState(false);
  const [section,setSection]=useState(0);

  useEffect(()=>{loadFicha();},[projectId]);

  const hashPassword=async(pass)=>{
    const enc=new TextEncoder();
    const buf=await crypto.subtle.digest("SHA-256",enc.encode(pass+"workwell_gic_2026"));
    return Array.from(new Uint8Array(buf)).map(b=>b.toString(16).padStart(2,"0")).join("");
  };

  const loadFicha=async()=>{
    setLoading(true);
    const{data}=await supabase.from("gic_fichas").select("id,codigo_caso,password_hash,status").eq("project_id",projectId).single();
    if(data){setFicha(data);setStep("unlock");}
    else{setFicha({project_id:projectId,codigo_caso:codigoCaso});setStep("create");}
    setLoading(false);
  };

  const createFicha=async()=>{
    if(!newPass||newPass.length<4){setError("Password deve ter pelo menos 4 caracteres");return;}
    if(newPass!==newPass2){setError("As passwords nao coincidem");return;}
    const hash=await hashPassword(newPass);
    const{data:ins}=await supabase.from("gic_fichas").insert({project_id:projectId,codigo_caso:ficha.codigo_caso,password_hash:hash,status:"rascunho"}).select().single();
    if(ins){setFicha(ins);setStep("form");setError("");}
  };

  const unlockFicha=async()=>{
    const hash=await hashPassword(password);
    if(hash!==ficha.password_hash){setError("Password incorrecta");return;}
    const{data}=await supabase.from("gic_fichas").select("*").eq("id",ficha.id).single();
    if(data){setFicha(data);setStep("form");setError("");}
  };

  const f=(k,v)=>setFicha(b=>({...b,[k]:v}));

  const saveFicha=async()=>{
    setSaving(true);
    const{password_hash,...d}=ficha;
    await supabase.from("gic_fichas").update({...d,updated_at:new Date().toISOString()}).eq("id",ficha.id);
    
    // Se tem data de follow-up, actualizar a fase correspondente no projecto
    if(ficha.data_followup_3meses){
      const{data:phases}=await supabase.from("project_phases").select("id,name").eq("project_id",projectId);
      if(phases){
        const followupPhase=phases.find(p=>p.name?.toLowerCase().includes("follow-up")||p.name?.toLowerCase().includes("follow up")||p.name?.toLowerCase().includes("3 meses"));
        if(followupPhase){
          await supabase.from("project_phases").update({end_date:ficha.data_followup_3meses}).eq("id",followupPhase.id);
        }
      }
      // Actualizar também a data de fim do projecto
      await supabase.from("projects").update({contract_end:ficha.data_followup_3meses,updated_at:new Date().toISOString()}).eq("id",projectId);
    }
    
    setSaved(true);setTimeout(()=>setSaved(false),2000);
    setSaving(false);
  };

  const signFicha=async()=>{
    const{data:{session}}=await supabase.auth.getSession();
    f("status","assinado");f("signed_at",new Date().toISOString());f("signed_by",session?.user?.email);
    await saveFicha();
  };

  if(loading)return(
    <div style={{position:"fixed",inset:0,background:"rgba(26,26,46,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
      <div style={{background:"white",borderRadius:12,padding:32,color:"#691FB1",fontFamily:"system-ui"}}>A carregar ficha...</div>
    </div>
  );

  const modalWrap=(children)=>(
    <div style={{position:"fixed",inset:0,background:"rgba(26,26,46,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,backdropFilter:"blur(4px)"}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()}>{children}</div>
    </div>
  );

  if(step==="create")return modalWrap(
    <div style={{background:"white",borderRadius:16,padding:32,width:420,boxShadow:"0 20px 56px rgba(0,0,0,0.22)",fontFamily:"system-ui"}}>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{fontSize:40,marginBottom:8}}>🔒</div>
        <h2 style={{margin:0,color:"#691FB1",fontSize:20,fontWeight:700}}>Criar ficha GIC protegida</h2>
        <p style={{margin:"8px 0 0",fontSize:13,color:"#4A4A6A"}}>Define uma password para proteger os dados da intervencao</p>
      </div>
      <div style={{background:"#EDE7F6",borderRadius:9,padding:12,marginBottom:16,fontSize:12,color:"#691FB1"}}>
        <strong>Codigo do caso:</strong> {ficha?.codigo_caso}
      </div>
      <div style={{display:"grid",gap:12}}>
        <div><label style={{fontSize:11,fontWeight:600,color:"#8888AA",display:"block",marginBottom:4}}>Password de acesso</label>
          <input type="password" value={newPass} onChange={e=>setNewPass(e.target.value)} placeholder="Minimo 4 caracteres"
            style={{width:"100%",padding:"9px 11px",border:"1px solid #E4DEFA",borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none",boxSizing:"border-box"}}/></div>
        <div><label style={{fontSize:11,fontWeight:600,color:"#8888AA",display:"block",marginBottom:4}}>Confirmar password</label>
          <input type="password" value={newPass2} onChange={e=>setNewPass2(e.target.value)} placeholder="Repetir password"
            style={{width:"100%",padding:"9px 11px",border:"1px solid #E4DEFA",borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none",boxSizing:"border-box"}}/></div>
        {error&&<div style={{fontSize:12,color:"#E74C3C",background:"#FDEDEC",padding:"8px 12px",borderRadius:7}}>{error}</div>}
      </div>
      <div style={{display:"flex",gap:10,marginTop:20}}>
        <button onClick={onClose} style={{flex:1,padding:10,border:"1px solid #E4DEFA",borderRadius:8,background:"white",color:"#4A4A6A",fontSize:13,cursor:"pointer",fontFamily:"system-ui"}}>Cancelar</button>
        <button onClick={createFicha} style={{flex:2,padding:10,border:"none",borderRadius:8,background:"#691FB1",color:"white",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"system-ui"}}>🔒 Criar ficha protegida</button>
      </div>
    </div>
  );

  if(step==="unlock")return modalWrap(
    <div style={{background:"white",borderRadius:16,padding:32,width:380,boxShadow:"0 20px 56px rgba(0,0,0,0.22)",fontFamily:"system-ui"}}>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{fontSize:40,marginBottom:8}}>🔐</div>
        <h2 style={{margin:0,color:"#691FB1",fontSize:20,fontWeight:700}}>Ficha GIC protegida</h2>
        <p style={{margin:"8px 0 0",fontSize:13,color:"#4A4A6A"}}>Introduz a password para aceder</p>
        <div style={{marginTop:8,fontSize:12,color:"#691FB1",fontWeight:600}}>Caso: {ficha?.codigo_caso}</div>
        {ficha?.status==="assinado"&&<div style={{marginTop:6,background:"#EAFAF1",color:"#27AE60",borderRadius:6,padding:"4px 10px",fontSize:11,fontWeight:700,display:"inline-block"}}>Assinado</div>}
      </div>
      <input type="password" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&unlockFicha()} placeholder="Password"
        style={{width:"100%",padding:"12px",border:`1px solid ${error?"#E74C3C":"#E4DEFA"}`,borderRadius:8,fontSize:14,fontFamily:"system-ui",outline:"none",boxSizing:"border-box",textAlign:"center",letterSpacing:4}}/>
      {error&&<div style={{fontSize:12,color:"#E74C3C",marginTop:8,textAlign:"center"}}>{error}</div>}
      <div style={{display:"flex",gap:10,marginTop:16}}>
        <button onClick={onClose} style={{flex:1,padding:10,border:"1px solid #E4DEFA",borderRadius:8,background:"white",color:"#4A4A6A",fontSize:13,cursor:"pointer",fontFamily:"system-ui"}}>Cancelar</button>
        <button onClick={unlockFicha} style={{flex:2,padding:10,border:"none",borderRadius:8,background:"#691FB1",color:"white",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"system-ui"}}>🔓 Desbloquear</button>
      </div>
    </div>
  );

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(26,26,46,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,backdropFilter:"blur(4px)"}} onClick={onClose}>
      <div style={{background:"white",borderRadius:16,width:700,maxHeight:"90vh",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 20px 56px rgba(0,0,0,0.22)",fontFamily:"system-ui"}} onClick={e=>e.stopPropagation()}>

        <div style={{background:"#691FB1",padding:"16px 24px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <h2 style={{margin:0,color:"white",fontSize:18,fontWeight:700}}>Ficha GIC — Gestao de Incidentes Criticos</h2>
            <p style={{margin:"3px 0 0",fontSize:12,color:"rgba(255,255,255,0.75)"}}>{projectName} - Caso: {ficha?.codigo_caso}</p>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {ficha?.status==="assinado"?<span style={{background:"#27AE60",color:"white",borderRadius:6,padding:"4px 12px",fontSize:12,fontWeight:700}}>Assinado</span>:<span style={{background:"#FEF9E7",color:"#F39C12",borderRadius:6,padding:"4px 12px",fontSize:12,fontWeight:700}}>Rascunho</span>}
            <button onClick={onClose} style={{background:"none",border:"none",color:"rgba(255,255,255,0.7)",fontSize:22,cursor:"pointer"}}>x</button>
          </div>
        </div>

        <div style={{padding:"10px 24px",background:"#EDE7F6",borderBottom:"1px solid #E4DEFA"}}>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {SECTIONS.map((s,i)=><button key={i} onClick={()=>setSection(i)} style={{background:section===i?"#691FB1":"white",border:`1px solid ${section===i?"#691FB1":"#E4DEFA"}`,borderRadius:5,color:section===i?"white":"#8888AA",padding:"3px 10px",fontSize:10,cursor:"pointer",fontFamily:"system-ui",fontWeight:section===i?700:400}}>{s}</button>)}
          </div>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>

          {section===0&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>1. Empresa e contacto</h3>
            <Row label="Nome da empresa"><FInput value={ficha?.empresa} onChange={v=>f("empresa",v)} placeholder="Nome da empresa cliente"/></Row>
            <Row label="Responsavel da empresa (quem acionou)"><FInput value={ficha?.responsavel_empresa} onChange={v=>f("responsavel_empresa",v)} placeholder="Nome e cargo"/></Row>
            <Row label="Contacto telefónico"><FInput value={ficha?.contacto_empresa} onChange={v=>f("contacto_empresa",v)} placeholder="912 345 678"/></Row>
            <Row label="Email"><FInput type="email" value={ficha?.email_empresa} onChange={v=>f("email_empresa",v)} placeholder="email@empresa.pt"/></Row>
          </div>}

          {section===1&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>2. Dados do incidente</h3>
            <Row label="Tipo de incidente"><FSelect value={ficha?.tipo_incidente} onChange={v=>f("tipo_incidente",v)} options={TIPO_INCIDENTE}/></Row>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <Row label="Data do incidente"><FInput type="date" value={ficha?.data_incidente} onChange={v=>f("data_incidente",v)}/></Row>
              <Row label="Hora do incidente"><FInput type="time" value={ficha?.hora_incidente} onChange={v=>f("hora_incidente",v)}/></Row>
            </div>
            <Row label="Local do incidente"><FSelect value={ficha?.local_incidente} onChange={v=>f("local_incidente",v)} options={LOCAIS}/></Row>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <Row label="Numero de colaboradores afetados"><FInput type="number" value={ficha?.num_colaboradores} onChange={v=>f("num_colaboradores",Number(v))} placeholder="0"/></Row>
              <Row label="Numero de lideres afetados"><FInput type="number" value={ficha?.num_lideres} onChange={v=>f("num_lideres",Number(v))} placeholder="0"/></Row>
            </div>
            <Row label="Equipas afetadas"><FInput value={ficha?.equipas_afetadas} onChange={v=>f("equipas_afetadas",v)} placeholder="Ex: Equipa de manutencao, linha norte"/></Row>
            <Row label="Descricao do incidente" note="Confidencial — nao partilhar sem autorizacao"><FTextarea value={ficha?.descricao_incidente} onChange={v=>f("descricao_incidente",v)} placeholder="Descreve o que aconteceu..." rows={4}/></Row>
          </div>}

          {section===2&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>3. Avaliacao de necessidades</h3>
            <div style={{background:"#EDE7F6",borderRadius:9,padding:12,marginBottom:16,fontSize:12,color:"#691FB1"}}>
              Avaliacao realizada pela Gestora de Caso no primeiro contacto com a empresa
            </div>
            <Row label="E preciso alguem no local no proprio dia?"><SimNao value={ficha?.presenca_local_proprio_dia} onChange={v=>f("presenca_local_proprio_dia",v)}/></Row>
            <Row label="Os lideres precisam de apoio para comunicar a ocorrencia as equipas?"><SimNao value={ficha?.apoio_lideres_comunicacao} onChange={v=>f("apoio_lideres_comunicacao",v)}/></Row>
            <Row label="Existem colaboradores em situacao de crise aguda?"><SimNao value={ficha?.colaboradores_crise_aguda} onChange={v=>f("colaboradores_crise_aguda",v)}/></Row>
            <Row label="Os colaboradores precisam de apoio imediato especializado?"><SimNao value={ficha?.precisa_apoio_imediato} onChange={v=>f("precisa_apoio_imediato",v)}/></Row>
            <Row label="A equipa sabe quais sao as respostas normais a um incidente critico?"><SimNao value={ficha?.equipa_conhece_respostas_normais} onChange={v=>f("equipa_conhece_respostas_normais",v)}/></Row>
            <Row label="Existem colaboradores que precisam de ajuda para gerir trauma?"><SimNao value={ficha?.colaboradores_precisam_ajuda_trauma} onChange={v=>f("colaboradores_precisam_ajuda_trauma",v)}/></Row>
            <Row label="A equipa esta pronta para seguir em frente?"><SimNao value={ficha?.equipa_pronta_seguir_frente} onChange={v=>f("equipa_pronta_seguir_frente",v)}/></Row>
            <Row label="Observacoes da avaliacao"><FTextarea value={ficha?.observacoes_avaliacao} onChange={v=>f("observacoes_avaliacao",v)} placeholder="Notas da gestora de caso..." rows={3}/></Row>
          </div>}

          {section===3&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>4. Intervencao</h3>
            <Row label="Houve intervencao em grupo?"><SimNao value={ficha?.intervencao_grupo} onChange={v=>f("intervencao_grupo",v)}/></Row>
            {ficha?.intervencao_grupo&&<>
              <Row label="Data da intervencao em grupo"><FInput type="date" value={ficha?.data_intervencao} onChange={v=>f("data_intervencao",v)}/></Row>
              <Row label="Terapeutas mobilizados"><FInput value={ficha?.terapeutas_mobilizados} onChange={v=>f("terapeutas_mobilizados",v)} placeholder="Nome dos terapeutas presentes"/></Row>
            </>}
            <Row label="Colaboradores identificados para acompanhamento individual" note="Lista sem dados clinicos — apenas referencia interna">
              <FTextarea value={ficha?.colaboradores_acompanhamento_individual} onChange={v=>f("colaboradores_acompanhamento_individual",v)} placeholder="Ex: 3 colaboradores encaminhados para psicoterapia individual via WOW..." rows={3}/>
            </Row>
          </div>}

          {section===4&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>5. Seguimento</h3>
            <div style={{background:"#E5F7FF",borderRadius:9,padding:12,marginBottom:16,fontSize:12,color:"#1A6FA0"}}>
              Follow-up obrigatorio aos 3 meses apos o incidente
            </div>
            <Row label="Data do follow-up @ 3 meses"><FInput type="date" value={ficha?.data_avaliacao_6semanas} onChange={v=>f("data_followup_3meses",v)}/></Row>
            <Row label="Observacoes do follow-up @ 3 meses"><FTextarea value={ficha?.observacoes_6semanas} onChange={v=>f("observacoes_followup",v)} placeholder="Estado geral da equipa apos 3 meses, continuidade do servico..." rows={3}/></Row>
          </div>}

        </div>

        <div style={{padding:"14px 24px",borderTop:"1px solid #E4DEFA",display:"flex",gap:10,alignItems:"center"}}>
          <button onClick={()=>setSection(s=>Math.max(0,s-1))} disabled={section===0}
            style={{background:"#F7F5FC",border:"1px solid #E4DEFA",borderRadius:7,color:section===0?"#8888AA":"#691FB1",padding:"8px 16px",fontSize:13,cursor:section===0?"not-allowed":"pointer",fontFamily:"system-ui"}}>
            Anterior
          </button>
          {section<4&&<button onClick={()=>setSection(s=>s+1)}
            style={{background:"#EDE7F6",border:"1px solid #691FB1",borderRadius:7,color:"#691FB1",padding:"8px 16px",fontSize:13,cursor:"pointer",fontFamily:"system-ui",fontWeight:600}}>
            Proxima
          </button>}
          <div style={{flex:1}}/>
          {saved&&<span style={{fontSize:12,color:"#27AE60",fontWeight:600}}>Guardado!</span>}
          <button onClick={saveFicha} disabled={saving}
            style={{background:"white",border:"1px solid #E4DEFA",borderRadius:7,color:"#4A4A6A",padding:"8px 16px",fontSize:13,cursor:"pointer",fontFamily:"system-ui"}}>
            {saving?"A guardar...":"Guardar"}
          </button>
          {ficha?.status!=="assinado"&&<button onClick={signFicha}
            style={{background:"#691FB1",border:"none",borderRadius:7,color:"white",padding:"8px 16px",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"system-ui"}}>
            Assinar Ficha
          </button>}
        </div>
      </div>
    </div>
  );
}
